<div class="error-state-container">
  <div class="error-message">
    Something went wrong. Try again in some time.
  </div>
  <div class="error-buttons">
    <button class="try-again-btn" (click)="onTryAgain()">
      Try Again
    </button>
    <button class="go-back-btn" (click)="onGoBack()">
      <div class="go-back-content">
        Go Back
      </div>
    </button>
  </div>
</div>
